import { render } from "./AssociationOverview.vue?vue&type=template&id=b3db91fe&scoped=true"
import script from "./AssociationOverview.vue?vue&type=script&lang=js"
export * from "./AssociationOverview.vue?vue&type=script&lang=js"

import "./AssociationOverview.vue?vue&type=style&index=0&id=b3db91fe&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3db91fe"]])

export default __exports__